
import { defineComponent } from 'vue'

/**
 * Component for displaying the picture in EmptyState.vue
 */
export default defineComponent({
  name: 'EmptyStatePicture',

  props: {
    pngImagePath: {
      type: String,
      required: true
    },
    webpImagePath: {
      type: String,
      default: ''
    },
    svgImagePath: {
      type: String,
      default: ''
    },
    width: {
      type: String,
      default: 'w-28'
    },
    height: {
      type: String,
      default: ''
    },
    altText: {
      type: String,
      default: 'This page has no data'
    },
    imageClasses: {
      type: String,
      default: 'mx-auto'
    }
  }
})
